import React from 'react'

import HTMLTranslation from 'components/html-translation'
import page from 'hoc/page'
import frontload from 'hoc/frontload'
import Loadable from 'react-loadable'
import { DI } from 'modules'
import Component from 'components/component'

const loading = () => null

const en = Loadable({
  loading,
  loader: () =>
    import(
      /* webpackChunkName: "about-en" */ 'submodules/translations/static-pages/about/en'
    ),
})
const ru = Loadable({
  loading,
  loader: () =>
    import(
      /* webpackChunkName: "about-ru" */ 'submodules/translations/static-pages/about/ru'
    ),
})
const es = Loadable({
  loading,
  loader: () =>
    import(
      /* webpackChunkName: "about-es" */ 'submodules/translations/static-pages/about/es'
    ),
})
const ar = Loadable({
  loading,
  loader: () =>
    import(
      /* webpackChunkName: "about-ar" */ 'submodules/translations/static-pages/about/ar'
    ),
})

class AboutContent extends Component {
  static preload(props) {
    const slug = 'about'
    return props.actions.frontpages.getFrontPage(slug)
  }

  render() {
    return <HTMLTranslation translations={{ en, ru, es, ar }} />
  }
}

export default page(DI(['frontpages'])(frontload(AboutContent, 'aboutContent')))
